import { filter, isEmpty } from 'lodash/fp';

import { CONTENT_SECTIONS } from '../../../content/sections';
import { ContentTiles } from '../../../../../types/__codegen__/sanity/graphql';
import getContentTilesData from '../../../../explained-term/detail/utils/get-content-tiles-data';

type Tile = {
  type: string;
};
type MapTilesContentProps = {
  cmsSectionContent: ContentTiles & {
    orderIndex: number;
  };
};

const mapTilesContent = ({ cmsSectionContent }: MapTilesContentProps) => {
  if (isEmpty(cmsSectionContent)) {
    return null;
  }

  const tilesData = cmsSectionContent?.tiles;
  const serviceTiles = filter((tileType: Tile) => tileType.type === 'service', tilesData);
  const explainedTermTiles = filter((tileType: Tile) => tileType.type === 'explainedTerm', tilesData);
  const contentTiles = getContentTilesData({ explainedTermTiles, serviceTiles });
  return {
    contentTiles,
    orderIndex: cmsSectionContent.orderIndex,
    type: CONTENT_SECTIONS.TILES,
  };
};

export default mapTilesContent;
